import { dashboardApi } from "./api"

export const fetchMonitoringDashboard = async () => {
    const response = await dashboardApi.get('/api/dg_link');
    if (response.data?.status) {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch dashboard data');
}